import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import Header from '@/common/header';
import { Footer } from '@/components/trial/footer';

// Estado terminal de /trial: a API não tinha trial nenhum para oferecer. Sem formulário — a versão
// antiga desta tela pedia cartão, e é isso que este componente existe para impedir.
export default function TrialUnavailable() {
  const { t } = useTranslation('pages/trial/index');

  return (
    <>
      <Header variant='primary' />
      <section className='mb-16 flex min-h-[420px] flex-col items-center justify-center gap-8 px-5 text-center'>
        <h1 className='max-w-[720px] text-2xl font-bold leading-[120%] text-white'>{t('trial_unavailable.title')}</h1>
        <Link href='/pricing' className='flex h-[50px] items-center justify-center rounded-md bg-[#AEF55C] px-8 font-bold uppercase text-black transition-opacity hover:opacity-80'>
          {t('trial_unavailable.cta')}
        </Link>
      </section>
      <Footer variant='primary' />
    </>
  );
}
